import React from "react";
import { ThemeBasedColorHeader } from "src/shared/modules/profile/theme/themeCheacker";

export default function OrderDetailsCard({ order, onChangeOrder }: any) {
    if (!order) return null;

    return (
        <div className="bg-white rounded shadow">

            <div className={`${ThemeBasedColorHeader()} text-white p-2 rounded-t`}>
                Order Details
            </div>

            <div className="p-2 text-sm space-y-1">
                <div className="flex justify-between">
                    <span>Order Id</span>
                    <span
                        className="flex gap-1 cursor-pointer"
                        onClick={onChangeOrder}
                    >
                        {order.Orderid}
                        <p className="text-red-500">X</p>
                    </span>
                </div>

                <div className="flex justify-between">
                    <span>Name</span>
                    <span>{order.CustomerName}</span>
                </div>

                <div className="flex justify-between">
                    <span>Status</span>
                    <span className="text-red-500">{order.OrderStatus}</span>
                </div>

                <div className="flex justify-between">
                    <span>Date</span>
                    <span>
                        {order.Orderdate}/{order.Ordertime}
                    </span>
                </div>
            </div>
        </div>
    );
}